var _style, _rect, _defs, _defs2, _defs3, _defs4, _defs5, _defs6, _defs7, _defs8, _defs9, _defs10, _defs11, _defs12, _defs13, _defs14;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSentineloneLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 83.8 59.4",
    style: {
      enableBackground: "new 0 0 83.8 59.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n\t.st1{enable-background:new    ;}\n\t.st2{clip-path:url(#SVGID_00000103254651730678500140000002421426922048288423_);}\n\t.st3{clip-path:url(#SVGID_00000144324450819440785650000014898525411240227484_);fill:#2795E3;}\n\t.st4{clip-path:url(#SVGID_00000071518001831496165590000005792538127881851022_);}\n\t.st5{clip-path:url(#SVGID_00000034791523891452427820000015317657179585146047_);fill:#2795E3;}\n\t.st6{clip-path:url(#SVGID_00000075127845308107684930000006252645129994009222_);}\n\t.st7{clip-path:url(#SVGID_00000143615191632247469720000004971743029372720015_);fill:#2795E3;}\n\t.st8{clip-path:url(#SVGID_00000040564118232276718060000006036277888498423438_);}\n\t.st9{clip-path:url(#SVGID_00000003063861413021242010000009767104061051981197_);fill:#2795E3;}\n\t.st10{clip-path:url(#SVGID_00000045583125590893025580000014457162538840417466_);}\n\t.st11{clip-path:url(#SVGID_00000097478612519151750240000002419779425665930910_);fill:#2795E3;}\n\t.st12{clip-path:url(#SVGID_00000010301663343401542110000005962462550285625020_);}\n\t.st13{clip-path:url(#SVGID_00000002369412496149122990000012885099390923073936_);fill:#2795E3;}\n\t.st14{clip-path:url(#SVGID_00000032625253111884321320000016773161031045362085_);}\n\t.st15{clip-path:url(#SVGID_00000083082805735705778990000016059503840843699872_);fill:#2795E3;}\n")), /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 84,
    height: 58,
    xlinkHref: "54C7F94310E5192B.png",
    transform: "matrix(1 0 0 1 -0.1967 1.4009)"
  }), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -0.2,
    y: 1.4,
    className: "st0",
    width: 84,
    height: 58
  })), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 9.8,
    y: 11.4,
    width: 64,
    height: 38
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000076591886397096536020000006959846728611844748_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000076591886397096536020000006959846728611844748_)"
    }
  }, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000058556445200603070610000009604661416686754957_",
    x: 40.6,
    y: 11.4,
    width: 3.3,
    height: 19.6
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000038403815576995948490000017235751202897976722_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000058556445200603070610000009604661416686754957_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 39.6,
    y: 10.4,
    style: {
      clipPath: "url(#SVGID_00000038403815576995948490000017235751202897976722_)",
      fill: "#2795E3"
    },
    width: 5.3,
    height: 21.6
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000076591886397096536020000006959846728611844748_)"
    }
  }, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000150783605368631479470000014615928540142573447_",
    d: "M44.7,35.8l3.3-2v-17c-1-0.7-2.1-1.2-3.3-1.5V35.8z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000116951793146293687780000009681996319753417405_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000150783605368631479470000014615928540142573447_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000116951793146293687780000009681996319753417405_)"
    }
  }, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000018959953035667875510000016576282412833606327_",
    x: -0.2,
    y: 1.4,
    width: 84,
    height: 58
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000024695857210759190940000010221588488023984572_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000018959953035667875510000016576282412833606327_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 43.7,
    y: 14.3,
    style: {
      clipPath: "url(#SVGID_00000024695857210759190940000010221588488023984572_)",
      fill: "#2795E3"
    },
    width: 5.3,
    height: 22.5
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000076591886397096536020000006959846728611844748_)"
    }
  }, _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000078026118311551192440000002849418235545836416_",
    d: "M36.5,33.8l3.3,2V15.3c-1.2,0.2-2.3,0.7-3.3,1.4V33.8z "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000183953208606403297290000011015303564726737807_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000078026118311551192440000002849418235545836416_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000183953208606403297290000011015303564726737807_)"
    }
  }, _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000008849679987516227770000001124922394283381895_",
    x: -0.2,
    y: 1.4,
    width: 84,
    height: 58
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000181796291361778614700000005928603251246746770_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000008849679987516227770000001124922394283381895_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 35.5,
    y: 14.3,
    style: {
      clipPath: "url(#SVGID_00000181796291361778614700000005928603251246746770_)",
      fill: "#2795E3"
    },
    width: 5.3,
    height: 22.5
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000076591886397096536020000006959846728611844748_)"
    }
  }, _defs7 || (_defs7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000116918434215253509410000017704778916693510582_",
    d: "M48.9,12.3v21.1l1.5-0.9c1.1-0.7,1.8-2,1.8-3.3v-9.9 C52.2,16.3,48.9,12.3,48.9,12.3"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000049196061189360248020000016098422186234599576_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000116918434215253509410000017704778916693510582_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000049196061189360248020000016098422186234599576_)"
    }
  }, _defs8 || (_defs8 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000066482528842164370440000011789072869176447878_",
    x: -0.2,
    y: 1.4,
    width: 84,
    height: 58
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000068644796054550084320000000982050514453059463_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000066482528842164370440000011789072869176447878_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 47.9,
    y: 11.3,
    style: {
      clipPath: "url(#SVGID_00000068644796054550084320000000982050514453059463_)",
      fill: "#2795E3"
    },
    width: 5.3,
    height: 23.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000076591886397096536020000006959846728611844748_)"
    }
  }, _defs9 || (_defs9 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000072981892859134409110000011061327700191516044_",
    d: "M32.4,29.1c0,1.3,0.6,2.6,1.8,3.3l1.5,0.9v-21 c0,0-3.3,4-3.3,6.9V29.1z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000153664978406270383010000006082354712085878168_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000072981892859134409110000011061327700191516044_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000153664978406270383010000006082354712085878168_)"
    }
  }, _defs10 || (_defs10 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000124150796800366579250000013963430745110857618_",
    x: -0.2,
    y: 1.4,
    width: 84,
    height: 58
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000016075197757951203920000009270178405675140533_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000124150796800366579250000013963430745110857618_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 31.4,
    y: 11.3,
    style: {
      clipPath: "url(#SVGID_00000016075197757951203920000009270178405675140533_)",
      fill: "#2795E3"
    },
    width: 5.3,
    height: 23
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000076591886397096536020000006959846728611844748_)"
    }
  }, _defs11 || (_defs11 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000116947626245094467020000011581999484184454332_",
    d: "M49.8,48.3v-8.7l1.3-0.6v9.3H49.8z M47.7,44.6 c0-0.5-0.2-0.9-0.5-1.3c-0.3-0.3-0.8-0.5-1.3-0.5c-0.5,0-0.9,0.2-1.2,0.5c-0.3,0.3-0.5,0.8-0.6,1.3H47.7z M45.9,48.4 c-0.9,0-1.7-0.3-2.3-0.9c-0.6-0.6-0.9-1.4-0.9-2.4c0-1,0.3-1.8,0.9-2.4c0.6-0.6,1.4-0.9,2.3-0.9c0.9,0,1.7,0.3,2.3,0.9 c0.6,0.6,0.9,1.3,0.9,2.3c0,0.2,0,0.4,0,0.6h-5c0,0.5,0.2,0.9,0.5,1.3c0.3,0.3,0.8,0.5,1.3,0.5c0.7,0,1.2-0.3,1.5-0.9h1.5 c-0.2,0.6-0.6,1.1-1.1,1.5C47.2,48.2,46.6,48.4,45.9,48.4z M37.5,41.9v1c0.4-0.7,1.1-1.1,2.1-1.1c0.7,0,1.3,0.2,1.8,0.7 c0.5,0.5,0.7,1.1,0.7,2v3.8h-1.3v-3.6c0-0.6-0.1-1-0.4-1.3c-0.3-0.3-0.7-0.5-1.2-0.5c-0.4,0-0.9,0.1-1.2,0.5 c-0.3,0.3-0.4,0.7-0.4,1.3v3.6h-1.3v-6.4H37.5z M33.6,48.3H35v-6.4h-1.3V48.3z M32.6,43h-1.6v3.5c0,0.2,0,0.4,0.2,0.5 c0.1,0.1,0.3,0.2,0.6,0.2h0.8v1.1h-1.1c-1.2,0-1.9-0.6-1.9-1.8v-5.6l1.4-0.6v1.6h1.6L32.6,43z M24.5,41.9v1 c0.4-0.7,1.1-1.1,2.1-1.1c0.7,0,1.3,0.2,1.8,0.7c0.5,0.5,0.7,1.1,0.7,2v3.8h-1.3v-3.6c0-0.6-0.1-1-0.4-1.3 c-0.3-0.3-0.7-0.5-1.2-0.5c-0.5,0-0.9,0.1-1.2,0.5c-0.3,0.3-0.4,0.7-0.4,1.3v3.6h-1.3v-6.4H24.5z M21,44.6 c0-0.5-0.2-0.9-0.5-1.3c-0.3-0.3-0.8-0.5-1.3-0.5c-0.5,0-0.9,0.2-1.2,0.5c-0.3,0.3-0.5,0.8-0.6,1.3H21z M19.2,48.4 c-0.9,0-1.7-0.3-2.3-0.9c-0.6-0.6-0.9-1.4-0.9-2.4c0-1,0.3-1.8,0.9-2.4c0.6-0.6,1.4-0.9,2.3-0.9c0.9,0,1.7,0.3,2.3,0.9 c0.6,0.6,0.9,1.3,0.9,2.3c0,0.2,0,0.4,0,0.6h-5c0,0.5,0.2,0.9,0.5,1.3c0.3,0.3,0.8,0.5,1.3,0.5c0.7,0,1.2-0.3,1.5-0.9h1.4 c-0.2,0.6-0.6,1.1-1.1,1.5C20.6,48.2,19.9,48.4,19.2,48.4z M12.5,41.2c-0.4,0-0.7,0.1-1,0.3c-0.3,0.2-0.4,0.5-0.4,0.9 c0,0.4,0.2,0.7,0.5,0.9c0.3,0.2,0.7,0.4,1.1,0.4c0.4,0.1,0.8,0.2,1.3,0.3c0.4,0.1,0.8,0.3,1.1,0.7c0.3,0.3,0.4,0.8,0.4,1.4 c0,0.6-0.3,1.1-0.8,1.6c-0.5,0.5-1.2,0.7-2,0.7c-0.9,0-1.6-0.2-2.1-0.6c-0.5-0.4-0.8-1-0.8-1.6h1.4c0,0.3,0.2,0.6,0.4,0.8 c0.2,0.2,0.6,0.3,1,0.3c0.4,0,0.8-0.1,1.1-0.3c0.5-0.4,0.5-1.1,0.2-1.6c-0.2-0.2-0.4-0.3-0.6-0.4c-0.3-0.1-0.6-0.2-0.8-0.2 c-0.3-0.1-0.6-0.1-0.9-0.2c-0.3-0.1-0.6-0.2-0.8-0.4c-0.3-0.2-0.5-0.4-0.6-0.6c-0.2-0.3-0.3-0.7-0.2-1c0-0.7,0.3-1.3,0.8-1.7 c0.5-0.4,1.2-0.6,2-0.6c0.8,0,1.5,0.2,2,0.5c0.5,0.4,0.8,0.9,0.8,1.6h-1.5c0-0.3-0.2-0.6-0.4-0.8C13.2,41.3,12.9,41.2,12.5,41.2 z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000020365714427367233440000017910089863664630918_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000116947626245094467020000011581999484184454332_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000020365714427367233440000017910089863664630918_)"
    }
  }, _defs12 || (_defs12 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000072278205621866968470000003872328821968557986_",
    x: 9.8,
    y: 39,
    width: 41.4,
    height: 9.4
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000013167845889006683590000015442172347614280380_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000072278205621866968470000003872328821968557986_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 8.8,
    y: 38,
    style: {
      clipPath: "url(#SVGID_00000013167845889006683590000015442172347614280380_)",
      fill: "#2795E3"
    },
    width: 43.4,
    height: 11.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000076591886397096536020000006959846728611844748_)"
    }
  }, _defs13 || (_defs13 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000183239105753233027380000013810182793371368341_",
    d: "M70.8,42.3c-0.4,0-0.9,0.1-1.3,0.3 c-0.4,0.2-0.7,0.5-0.9,0.9c-0.3,0.4-0.4,0.9-0.4,1.4h5c0-0.5-0.1-1-0.3-1.5c-0.2-0.4-0.5-0.7-0.9-0.9 C71.7,42.4,71.3,42.3,70.8,42.3z M70.8,47.8c0.6,0,1.1-0.1,1.6-0.5c0.4-0.3,0.7-0.8,0.8-1.3h0.6c-0.1,0.6-0.4,1.2-1,1.6 c-0.5,0.4-1.2,0.6-2,0.6c-0.6,0-1.1-0.1-1.6-0.4c-0.5-0.3-0.9-0.6-1.1-1.1c-0.3-0.5-0.4-1.1-0.4-1.7c0-0.6,0.1-1.2,0.4-1.7 c0.3-0.5,0.6-0.9,1.1-1.1c0.5-0.3,1-0.4,1.6-0.4c0.6,0,1.1,0.1,1.6,0.4c0.4,0.2,0.8,0.6,1,1c0.2,0.4,0.3,0.9,0.3,1.3 c0,0.2,0,0.4-0.1,0.6h-5.5c0,0.5,0.1,1,0.4,1.5c0.2,0.4,0.5,0.7,0.9,0.9C69.9,47.7,70.4,47.8,70.8,47.8z M64.3,41.8 c0.8,0,1.4,0.2,1.8,0.7c0.5,0.5,0.7,1.1,0.7,2v3.6h-0.5v-3.6c0-0.7-0.2-1.3-0.6-1.7c-0.4-0.4-0.9-0.6-1.6-0.6 c-0.6,0-1.2,0.2-1.7,0.7c-0.4,0.4-0.6,1.1-0.6,1.9v3.3h-0.5v-6.2h0.5v1.6c0.1-0.5,0.4-1,0.9-1.3C63.2,42,63.7,41.8,64.3,41.8z  M56.3,40.6c-0.6,0-1.2,0.1-1.8,0.4c-0.5,0.3-1,0.7-1.2,1.3c-0.3,0.6-0.5,1.3-0.5,1.9c0,0.7,0.1,1.3,0.5,1.9 c0.3,0.5,0.7,1,1.2,1.3c1.1,0.6,2.4,0.6,3.5,0c0.5-0.3,1-0.7,1.2-1.3c0.3-0.6,0.5-1.3,0.5-1.9c0-0.7-0.1-1.3-0.5-1.9 c-0.3-0.5-0.7-1-1.2-1.3C57.5,40.8,56.9,40.6,56.3,40.6z M56.3,40.1c0.7,0,1.4,0.2,2.1,0.5c0.6,0.3,1.1,0.8,1.4,1.5 c0.3,0.7,0.5,1.4,0.5,2.1c0,0.7-0.2,1.5-0.5,2.1c-0.3,0.6-0.8,1.1-1.4,1.5c-1.3,0.7-2.8,0.7-4.1,0c-0.6-0.3-1.1-0.9-1.4-1.5 c-0.3-0.7-0.5-1.4-0.5-2.1c0-0.7,0.2-1.5,0.5-2.1c0.3-0.6,0.8-1.1,1.4-1.5C54.9,40.3,55.6,40.1,56.3,40.1z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000146477936590750301530000011274960592226482057_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000183239105753233027380000013810182793371368341_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000146477936590750301530000011274960592226482057_)"
    }
  }, _defs14 || (_defs14 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000103243539013883356670000010196484209909742466_",
    x: 52.3,
    y: 40.1,
    width: 21.5,
    height: 8.3
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000160183604266774204840000012593334104438954913_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000103243539013883356670000010196484209909742466_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 51.3,
    y: 39.1,
    style: {
      clipPath: "url(#SVGID_00000160183604266774204840000012593334104438954913_)",
      fill: "#2795E3"
    },
    width: 23.5,
    height: 10.3
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSentineloneLogo);
export default __webpack_public_path__ + "static/media/sentinelone-logo.b9a8fd3138924bfe438f156b9fcb8955.svg";
export { ForwardRef as ReactComponent };